module.exports = __webpack_public_path__ + "static/img/niksen3.cf4e5aca.jpg";